export interface LinhaCalculada {
  unitPriceBase: number
  unitPrice: number
  settlementAmount: number
  creditAmount: number
  calcBaseValue: number
  taxContribution: number
}

function escalar(valor: number, casas: number): number {
  return Number((valor * 10 ** casas).toPrecision(15))
}

export function arredondarParaBaixo(valor: number, casas: number): number {
  return Math.trunc(escalar(valor, casas)) / 10 ** casas
}

export function arredondarParaCima(valor: number, casas: number): number {
  const escalado = escalar(valor, casas)
  return (escalado < 0 ? Math.floor(escalado) : Math.ceil(escalado)) / 10 ** casas
}

export function arredondar(valor: number, casas = 2): number {
  return Math.round(escalar(valor, casas)) / 10 ** casas
}

export function calcularLinha(preco: number, qtd: number, taxa: number, descontoPercentual = 0): LinhaCalculada {
  const unitPriceBase = preco
  const unitPrice = (preco * (100 - descontoPercentual)) / 100
  const calcBaseValue = arredondarParaBaixo(unitPrice * qtd, 10)

  return {
    unitPriceBase,
    unitPrice,
    settlementAmount: unitPriceBase - unitPrice,
    creditAmount: arredondarParaBaixo(unitPrice * qtd, 2),
    calcBaseValue,
    taxContribution: arredondarParaCima(calcBaseValue * (taxa / 100), 2)
  }
}
